import React, { createContext } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
// import a plugin
import { Toaster } from "react-hot-toast";
// router
import Router from "./routes";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";

// notification alert
import { RtlLayout } from "src/components";
// JWT context
import { AuthProvider } from "src/contexts/AuthContext";
// redux
import { persistor, store } from "src/redux/store";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ReactQueryDevtools } from "react-query/devtools";
import { createContextualCan } from "@casl/react";
// ----------------------------------------------------------------------

export default function App() {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            staleTime: 1000 * 10,
          },
        },
      })
  );
  return (
    <ReduxProvider store={store}>
      <ThemeConfig>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RtlLayout>
              <GlobalStyles />
              <Toaster />
              <Router />
            </RtlLayout>{" "}
          </AuthProvider>
        </QueryClientProvider>{" "}
      </ThemeConfig>
    </ReduxProvider>
  );
}
